<template>
    <UContainer class="px-4 py-20 md:py-32">
        <div class="mx-auto flex max-w-lg flex-col items-center gap-6 text-center">
            <p class="font-roboto text-6xl font-black text-primary-500 md:text-8xl">
                {{ statusCode }}
            </p>
            <h1 class="font-roboto text-2xl font-bold text-neutral-900 md:text-4xl">
                {{ title }}
            </h1>
            <p class="font-manrope text-base leading-7 text-neutral-600 md:text-lg">
                {{ description }}
            </p>
            <div class="mt-2 flex flex-wrap items-center justify-center gap-3">
                <UButton
                    label="Go to homepage"
                    color="primary"
                    size="lg"
                    class="font-manrope font-bold"
                    :to="homeTo"
                    @click="onHome"
                />
                <UButton
                    label="Contact us"
                    color="neutral"
                    variant="outline"
                    size="lg"
                    class="font-manrope font-bold"
                    :to="contactTo"
                    @click="onContact"
                />
            </div>
        </div>
    </UContainer>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
    statusCode?: number
    clearNuxtError?: boolean
}>(), {
    statusCode: 404,
    clearNuxtError: false,
})

const is404 = computed(() => props.statusCode === 404)
const title = computed(() => (is404.value ? 'Page not found' : 'Something went wrong'))
const description = computed(() => (
    is404.value
        ? "The page you're looking for doesn't exist or has been moved."
        : 'An unexpected error occurred.'
))

const homeTo = computed(() => (props.clearNuxtError ? undefined : '/'))
const contactTo = computed(() => (props.clearNuxtError ? undefined : '/contact'))

const onHome = () => {
    if (props.clearNuxtError) {
        clearError({ redirect: '/' })
    }
}

const onContact = () => {
    if (props.clearNuxtError) {
        clearError({ redirect: '/contact' })
    }
}
</script>
